webpackJsonp([101],{

/***/ 184:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(16);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(351);

var _vuex2 = _interopRequireDefault(_vuex);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

_vue2.default.use(_vuex2.default);

exports.default = new _vuex2.default.Store({
  state: {
    userInfo: null,
    loading: false,
    isCollapse: false,
    logoShow: false,
    uniquerouter: true,
    menus: [],
    rightNav: {},
    noMenuPages: [{ path: '/dashboard', title: '首页' }, { path: '/user/profile', title: '个人信息' }, { path: '/user/changepwd', title: '修改密码' }, { path: '/Notices', title: '通知公告' }, { path: '/Mail', title: '站内信' }],
    tabnavBox: [{
      title: '首页',
      path: '/dashboard'
    }]
  },
  mutations: {
    addTab: function addTab(state, arg) {
      for (var i = 0; i < state.tabnavBox.length; i++) {
        if (state.tabnavBox[i].path === arg.path) {
          return false;
        }
      }
      state.tabnavBox.push({
        title: arg.title,
        path: arg.path
      });
    },
    openMenu: function openMenu(state, arg) {
      state.rightNav = arg;
    },
    removeTab: function removeTab(state, arg) {
      var index = state.tabnavBox.findIndex(function (value, key) {
        return value.path === arg.tabItem.path;
      });
      state.tabnavBox.splice(index, 1);
      if (arg.tabItem.path === arg.fullPath) {
        var tabActive = state.tabnavBox[index] || state.tabnavBox[index - 1];
        arg.router.push(tabActive.path);
      }
    },
    removeOtherTab: function removeOtherTab(state, arg) {
      state.tabnavBox = [{
        title: '首页',
        path: '/dashboard'
      }];
      if (arg.all) {
        arg.router.push('/dashboard');
        return false;
      }
      state.tabnavBox.push(arg.tabItem);
      arg.router.push(arg.tabItem.path);
    },
    collapse: function collapse(state, arg) {
      state.isCollapse = !state.isCollapse;
      if (state.logoShow) {
        setTimeout(function () {
          state.logoShow = false;
        }, 300);
      } else {
        state.logoShow = true;
      }
    }
  },
  actions: {
    addTab: function addTab(_ref, arg) {
      var commit = _ref.commit;

      commit('addTab', arg);
    },
    openMenu: function openMenu(_ref2, arg) {
      var commit = _ref2.commit;

      commit('openMenu', arg);
    },
    removeTab: function removeTab(_ref3, arg) {
      var commit = _ref3.commit;

      commit('removeTab', arg);
    },
    removeOtherTab: function removeOtherTab(_ref4, arg) {
      var commit = _ref4.commit;

      commit('removeOtherTab', arg);
    },
    collapse: function collapse(_ref5, arg) {
      var commit = _ref5.commit;

      commit('collapse', arg);
    }
  }
});

/***/ }),

/***/ 191:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_unfold_vue__ = __webpack_require__(206);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71317902_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_unfold_vue__ = __webpack_require__(725);
function injectStyle (ssrContext) {
  __webpack_require__(712)
}
var normalizeComponent = __webpack_require__(93)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-71317902"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_unfold_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71317902_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_unfold_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 203:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),

/***/ 204:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);






function getMediaDuration(fileUrl) {
    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var audioElement = new Audio(fileUrl);
        audioElement.addEventListener("loadedmetadata", function (_event) {
            var duration = parseInt(audioElement.duration);
            resolve(duration);
        });
    });
}

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "custom-upload",
    inheritAttrs: false,
    props: {
        fileList: {
            type: [Array, null],
            default: function _default() {
                return [];
            }
        },
        onlyUpload: Boolean,
        listType: {
            type: String,
            default: 'list'
        }
    },
    data: function data() {
        return {
            preview_url: "",
            fileShow: false,
            preview_visible: false,
            document_suffix: ".txt,.doc,.docx,.xls,.xlsx,.pdf",
            image_suffix: ".jpg,.png,.gif,.bmp",
            all_suffix: ".txt,.doc,.xls,.ppt,.pdf,.jpg,.png,.gif,.bmp,.docx,.xlsx,.pptx,.mp4,.avi,.mov"
        };
    },

    methods: {
        url: function url() {
            var API_UPLOAD_URL = "https://upload.mianzhoutong.com.cn/upload/";
            return API_UPLOAD_URL;
        },
        before: function before() {
            return false;
        },
        before_remove: function before_remove(file) {
            var that = this;
            if (file && file.status === "success") {
                return this.$confirm("\u786E\u5B9A\u79FB\u9664 \uFF1F", "提示", {}).then(function () {
                    that.remove(file);
                    return reject(false);
                }, function () {
                    reject(false);
                });
            }
        },
        remove: function remove(file) {
            if (file && file.status === "success") {
                var index = this.fileList.findIndex(function (item) {
                    return file.url == item.url;
                });
                this.fileList.splice(index, 1);
            }
            return false;
        },
        change: function change(file) {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var that, loading, formData, config, res, _fileList, i, item;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                that = _this;
                                loading = _this.$loading({
                                    lock: true,
                                    text: "上传中...",
                                    spinner: "el-icon-loading",
                                    background: "rgba(0, 0, 0, 0.7)"
                                });

                                if (!(file && file.status === "ready")) {
                                    _context.next = 35;
                                    break;
                                }

                                formData = new FormData();

                                formData.set("file", file.raw);
                                _context.prev = 5;
                                config = {
                                    headers: {
                                        "Content-type": "multipart/form-data"
                                    }
                                };
                                _context.next = 9;
                                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(that.url(), formData, config);

                            case 9:
                                res = _context.sent;

                                if (!(res.status == 200 && res.data.status == 2000)) {
                                    _context.next = 29;
                                    break;
                                }

                                if (!res.data.errors.length) {
                                    _context.next = 15;
                                    break;
                                }

                                _this.$message.error("上传失败," + res.data.errors[0].error);
                                _context.next = 29;
                                break;

                            case 15:
                                i = 0;

                            case 16:
                                if (!(i < res.data.files.length)) {
                                    _context.next = 25;
                                    break;
                                }

                                item = res.data.files[i];

                                if (!/mp3|mp4/.test(item.ext)) {
                                    _context.next = 22;
                                    break;
                                }

                                _context.next = 21;
                                return getMediaDuration(item.url);

                            case 21:
                                item.duration = _context.sent;

                            case 22:
                                i++;
                                _context.next = 16;
                                break;

                            case 25:
                                (_fileList = _this.fileList).push.apply(_fileList, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(res.data.files));
                                _this.$emit('change', _this.fileList);
                                _this.$emit('update:fileList', _this.fileList);
                                if (_this.onlyUpload) {
                                    _this.fileList.splice(0, 1);
                                }

                            case 29:
                                _context.next = 34;
                                break;

                            case 31:
                                _context.prev = 31;
                                _context.t0 = _context["catch"](5);

                                _this.$message.error("网络异常，请稍后重试");

                            case 34:
                                loading.close();

                            case 35:
                                return _context.abrupt("return", false);

                            case 36:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, _this, [[5, 31]]);
            }))();
        },
        preview: function preview(file) {
            window.open(file.viewurl);
        }
    }
});

/***/ }),

/***/ 205:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            mediaType: 'mp4',
            src: '',
            visible: false
        };
    },

    computed: {
        title: function title() {
            return this.mediaType === 'mp4' ? '视频预览' : '音频预览';
        }
    },
    watch: {
        visible: function visible(val) {
            if (!val) {
                this.src = '';
            }
        }
    },
    methods: {
        show: function show(src, type) {
            var _this = this;

            this.visible = true;
            this.src = src;
            this.mediaType = type;
            if (!/mp4|mp3/.test(type)) {
                this.mediaType = 'mp4';
            }
            this.$nextTick(function () {
                _this.$refs.playVideo.play();
            });
        },
        VideoClose: function VideoClose() {
            this.visible = false;
        }
    }
});

/***/ }),

/***/ 206:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "unfold",
  data: function data() {
    return {
      showBtn: true
    };
  },

  props: {
    tip: {
      type: String,
      default: '全文'
    },

    data: {
      type: String,
      default: ''
    },

    maxLen: {
      type: Number,
      default: 80
    }
  },
  computed: {
    sliceStr: function sliceStr() {
      if (this.data != null) {
        return this.data.substring(0, this.maxLen) + "...";
      }
      return '';
    }
  }
});

/***/ }),

/***/ 294:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_custom_upload_vue__ = __webpack_require__(204);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c360b3e6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_custom_upload_vue__ = __webpack_require__(726);
function injectStyle (ssrContext) {
  __webpack_require__(713)
}
var normalizeComponent = __webpack_require__(93)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c360b3e6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_custom_upload_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c360b3e6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_custom_upload_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 320:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  apiServer: {
    Admin: "/api-admin",
    Base: "/api-base",
    CMS: "/api-cms",
    Activiti: "/api-activiti",
    Zuul: "/zuul" },

  dictionary: {
    DANGEROUS_OPERATION_TYPE: "DANGEROUS_OPERATION_TYPE",
    STANDARD_LEVEL: "STANDARD_LEVEL",
    ENTERPRISE_CATEGORY: "ENTERPRISE_CATEGORY",
    OPERATION_FORM: "OPERATION_FORM" },

  type_dictionary: {
    OPERATING_PROCEDURES: '92793b134d4f442b9b1e0782917e395a'
  },

  HotWork: {
    LGNITION_TASK: 'LgnitionTask',
    SIGN_IMG: 'signImg',
    SCENE_IMG: "sceneImg",
    PRELIMINARY_IMG: "preliminaryImg",
    ON_SITE_IMG: "onSiteImg",
    WORK_IMG: 'workImg',
    WHEN_HOT_SIGN_IMG: 'whenHotSignImg',
    WHEN_HOT_SCENE_IMG: 'whenHotSceneImg',
    ACCEPTANCE_SIGN_IMG: 'acceptanceSignImg',
    ACCEPTANCE_SCENE_IMG: 'acceptanceSceneImg',
    Type: {
      FIRE_NAME: 'FIRE',
      BLIND_NAME: 'BLIND',
      GROUND_NAME: 'GROUND',
      LIFT_NAME: 'LIFT',
      LIMIT_NAME: 'LIMIT',
      TEMP_NAME: 'TEMP',
      HIGH_NAME: 'HIGH',
      BROKEN_NAME: 'BROKEN' }
  },

  HotWorkRole: {
    ON_SITE: 37,
    ACCEPTANCE: 38 },
  SystemInitRole: {
    EnterpriseAdmin: 45,
    SubEnterpriseAdmin: 46 },

  Activiti: 'activiti',
  FIRE_ACTION: "https://api.mianzhoutong.com.cn/" + '/api-activiti/task/createAttachment',

  RelevantExamineResultImpotUrl: "https://api.mianzhoutong.com.cn/" + '/api-cms/RelevantExamineResult/importData'
};

/***/ }),

/***/ 321:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(16);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(727);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var Home = function Home() {
  return __webpack_require__.e/* import() */(43).then(__webpack_require__.bind(null, 807));
};
var Dashboard = function Dashboard() {
  return __webpack_require__.e/* import() */(46).then(__webpack_require__.bind(null, 770));
};
var notFound = function notFound() {
  return __webpack_require__.e/* import() */(96).then(__webpack_require__.bind(null, 858));
};
var notPermission = function notPermission() {
  return __webpack_require__.e/* import() */(98).then(__webpack_require__.bind(null, 857));
};
var PotentialCheckTable = function PotentialCheckTable() {
  return __webpack_require__.e/* import() */(49).then(__webpack_require__.bind(null, 820));
};
var PotentialCheckPlan = function PotentialCheckPlan() {
  return __webpack_require__.e/* import() */(50).then(__webpack_require__.bind(null, 818));
};
var PotentialExaminationPre = function PotentialExaminationPre() {
  return __webpack_require__.e/* import() */(69).then(__webpack_require__.bind(null, 824));
};
var PotentialAssignmentPre = function PotentialAssignmentPre() {
  return __webpack_require__.e/* import() */(70).then(__webpack_require__.bind(null, 826));
};
var PotentialApplyCancelPre = function PotentialApplyCancelPre() {
  return __webpack_require__.e/* import() */(32).then(__webpack_require__.bind(null, 821));
};

var PotentialRectificationPre = function PotentialRectificationPre() {
  return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, 828));
};
var PotentialFilePre = function PotentialFilePre() {
  return __webpack_require__.e/* import() */(31).then(__webpack_require__.bind(null, 825));
};
var potentialCheckRecord = function potentialCheckRecord() {
  return __webpack_require__.e/* import() */(72).then(__webpack_require__.bind(null, 819));
};

var Sms = function Sms() {
  return __webpack_require__.e/* import() */(91).then(__webpack_require__.bind(null, 834));
};

var PreExpirationConfig = function PreExpirationConfig() {
  return __webpack_require__.e/* import() */(92).then(__webpack_require__.bind(null, 829));
};

var Integralset = function Integralset() {
  return __webpack_require__.e/* import() */(93).then(__webpack_require__.bind(null, 809));
};
var Integralist = function Integralist() {
  return __webpack_require__.e/* import() */(67).then(__webpack_require__.bind(null, 808));
};

var organList = function organList() {
  return __webpack_require__.e/* import() */(62).then(__webpack_require__.bind(null, 803));
};
var postList = function postList() {
  return __webpack_require__.e/* import() */(61).then(__webpack_require__.bind(null, 804));
};

var EnterpriseInfo = function EnterpriseInfo() {
  return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 789));
};

var Driver = function Driver() {
  return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, 788));
};

var Stevedore = function Stevedore() {
  return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 800));
};

var Escort = function Escort() {
  return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 790));
};

var SafetyInput = function SafetyInput() {
  return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 793));
};

var SafetyPerson = function SafetyPerson() {
  return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 795));
};

var MonitorPerson = function MonitorPerson() {
  return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 791));
};

var NetworkDocumen = function NetworkDocumen() {
  return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 792));
};

var Vehicle = function Vehicle() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 802));
};

var SafetyMeeting = function SafetyMeeting() {
  return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 794));
};

var SafetyTrained = function SafetyTrained() {
  return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 796));
};

var Accident = function Accident() {
  return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 787));
};

var SpecialPersonnel = function SpecialPersonnel() {
  return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 798));
};

var SpecialEquipment = function SpecialEquipment() {
  return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 797));
};

var User = function User() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 801));
};

var FileSign = function FileSign() {
  return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 805));
};

var FirstBusReport = function FirstBusReport() {
  return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, 806));
};

var Document = function Document() {
  return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 771));
};

var RiskUnit = function RiskUnit() {
  return __webpack_require__.e/* import() */(57).then(__webpack_require__.bind(null, 833));
};

var RiskEvent = function RiskEvent() {
  return __webpack_require__.e/* import() */(58).then(__webpack_require__.bind(null, 832));
};

var RiskControl = function RiskControl() {
  return __webpack_require__.e/* import() */(44).then(__webpack_require__.bind(null, 831));
};

var Inspection = function Inspection() {
  return __webpack_require__.e/* import() */(64).then(__webpack_require__.bind(null, 830));
};

var RegulatorPotentialTask = function RegulatorPotentialTask() {
  return __webpack_require__.e/* import() */(55).then(__webpack_require__.bind(null, 817));
};
var RegulatorSafetyMeetingTask = function RegulatorSafetyMeetingTask() {
  return __webpack_require__.e/* import() */(56).then(__webpack_require__.bind(null, 815));
};
var RegulatorWorkTask = function RegulatorWorkTask() {
  return __webpack_require__.e/* import() */(45).then(__webpack_require__.bind(null, 853));
};
var RegulatorTrainTask = function RegulatorTrainTask() {
  return __webpack_require__.e/* import() */(47).then(__webpack_require__.bind(null, 778));
};

var Notices = function Notices() {
  return __webpack_require__.e/* import() */(51).then(__webpack_require__.bind(null, 852));
};

var Mail = function Mail() {
  return __webpack_require__.e/* import() */(80).then(__webpack_require__.bind(null, 851));
};

var Password = function Password() {
  return __webpack_require__.e/* import() */(63).then(__webpack_require__.bind(null, 766));
};

var UserInfo = function UserInfo() {
  return __webpack_require__.e/* import() */(65).then(__webpack_require__.bind(null, 767));
};

var violationList = function violationList() {
  return __webpack_require__.e/* import() */(95).then(__webpack_require__.bind(null, 854));
};

var accidentcases = function accidentcases() {
  return __webpack_require__.e/* import() */(36).then(__webpack_require__.bind(null, 846));
};
var learningrecord = function learningrecord() {
  return __webpack_require__.e/* import() */(34).then(__webpack_require__.bind(null, 848));
};
var Study = function Study() {
  return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 849));
};
var technicalnorm = function technicalnorm() {
  return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 850));
};
var law = function law() {
  return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 847));
};

var reservePlan = function reservePlan() {
  return __webpack_require__.e/* import() */(40).then(__webpack_require__.bind(null, 785));
};
var troops = function troops() {
  return __webpack_require__.e/* import() */(39).then(__webpack_require__.bind(null, 786));
};
var material = function material() {
  return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 784));
};
var drill = function drill() {
  return __webpack_require__.e/* import() */(33).then(__webpack_require__.bind(null, 783));
};

var MeetTable = function MeetTable() {
  return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 814));
};
var potentialCheck = function potentialCheck() {
  return __webpack_require__.e/* import() */(48).then(__webpack_require__.bind(null, 822));
};

var potentialReview = function potentialReview() {
  return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, 860));
};
var potentialRecord = function potentialRecord() {
  return __webpack_require__.e/* import() */(60).then(__webpack_require__.bind(null, 827));
};
var potentialDangerRecord = function potentialDangerRecord() {
  return __webpack_require__.e/* import() */(97).then(__webpack_require__.bind(null, 823));
};
var Logbook = function Logbook() {
  return __webpack_require__.e/* import() */(68).then(__webpack_require__.bind(null, 810));
};
var Assess = function Assess() {
  return __webpack_require__.e/* import() */(71).then(__webpack_require__.bind(null, 769));
};
var Adas = function Adas() {
  return __webpack_require__.e/* import() */(99).then(__webpack_require__.bind(null, 768));
};
var Monitoring = function Monitoring() {
  return __webpack_require__.e/* import() */(73).then(__webpack_require__.bind(null, 816));
};

var Questions = function Questions() {
  return __webpack_require__.e/* import() */(66).then(__webpack_require__.bind(null, 777));
};
var Paper = function Paper() {
  return __webpack_require__.e/* import() */(53).then(__webpack_require__.bind(null, 776));
};
var Courseware = function Courseware() {
  return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 775));
};
var Course = function Course() {
  return __webpack_require__.e/* import() */(38).then(__webpack_require__.bind(null, 774));
};
var Train = function Train() {
  return __webpack_require__.e/* import() */(37).then(__webpack_require__.bind(null, 779));
};
var Traintask = function Traintask() {
  return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 782));
};
var TrainTaskDetail = function TrainTaskDetail() {
  return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 780));
};
var TrainTaskTotalDetail = function TrainTaskTotalDetail() {
  return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 781));
};

var safetyTrainingProgramList = function safetyTrainingProgramList() {
  return __webpack_require__.e/* import() */(75).then(__webpack_require__.bind(null, 864));
};
var trainingTask = function trainingTask() {
  return __webpack_require__.e/* import() */(74).then(__webpack_require__.bind(null, 865));
};
var latojaManagement = function latojaManagement() {
  return __webpack_require__.e/* import() */(76).then(__webpack_require__.bind(null, 863));
};

var myExam = function myExam() {
  return __webpack_require__.e/* import() */(78).then(__webpack_require__.bind(null, 861));
};
var myTrain = function myTrain() {
  return __webpack_require__.e/* import() */(77).then(__webpack_require__.bind(null, 862));
};

var ent = function ent() {
  return __webpack_require__.e/* import() */(79).then(__webpack_require__.bind(null, 856));
};

var Login = function Login(resolve) {
  return __webpack_require__.e/* require */(52).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(811)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var workplanTable = function workplanTable() {
  return __webpack_require__.e/* import() */(35).then(__webpack_require__.bind(null, 855));
};

var WorkStatistics = function WorkStatistics() {
  return __webpack_require__.e/* import() */(59).then(__webpack_require__.bind(null, 845));
};
var UserStatistics = function UserStatistics() {
  return __webpack_require__.e/* import() */(83).then(__webpack_require__.bind(null, 842));
};
var VehicleStatistics = function VehicleStatistics() {
  return __webpack_require__.e/* import() */(82).then(__webpack_require__.bind(null, 843));
};
var RiskStatistics = function RiskStatistics() {
  return __webpack_require__.e/* import() */(85).then(__webpack_require__.bind(null, 840));
};
var PotentialStatistics = function PotentialStatistics() {
  return __webpack_require__.e/* import() */(86).then(__webpack_require__.bind(null, 839));
};
var AccidentStatistics = function AccidentStatistics() {
  return __webpack_require__.e/* import() */(90).then(__webpack_require__.bind(null, 835));
};
var SafetyMeetingStatistics = function SafetyMeetingStatistics() {
  return __webpack_require__.e/* import() */(84).then(__webpack_require__.bind(null, 841));
};
var VehicleViolationStatistics = function VehicleViolationStatistics() {
  return __webpack_require__.e/* import() */(81).then(__webpack_require__.bind(null, 844));
};
var LogbookWeekStatictis = function LogbookWeekStatictis() {
  return __webpack_require__.e/* import() */(87).then(__webpack_require__.bind(null, 838));
};
var LogbookMonthStatictis = function LogbookMonthStatictis() {
  return __webpack_require__.e/* import() */(88).then(__webpack_require__.bind(null, 837));
};
var LogbookAbnormalStatictis = function LogbookAbnormalStatictis() {
  return __webpack_require__.e/* import() */(89).then(__webpack_require__.bind(null, 836));
};

var EnterpriseUploadFile = function EnterpriseUploadFile() {
  return __webpack_require__.e/* import() */(41).then(__webpack_require__.bind(null, 813));
};
var EnterpriseUploadDetailFile = function EnterpriseUploadDetailFile() {
  return __webpack_require__.e/* import() */(42).then(__webpack_require__.bind(null, 812));
};

var DrivingLine = function DrivingLine() {
  return __webpack_require__.e/* import() */(94).then(__webpack_require__.bind(null, 773));
};
var AddDrivingLine = function AddDrivingLine() {
  return __webpack_require__.e/* import() */(54).then(__webpack_require__.bind(null, 772));
};
var information = function information() {
  return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 859));
};

var StaffInfo = function StaffInfo() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 799));
};

_vue2.default.use(_vueRouter2.default);
var router = new _vueRouter2.default({
  mode: 'hash',
  routes: [{
    path: '/login',
    name: '登录',
    component: Login
  }, {
    path: '/404',
    name: 'notFound',
    component: notFound
  }, {
    path: '/401',
    name: 'notPermission',
    component: notPermission
  }, {
    path: '/',
    name: 'home',
    component: Home,
    redirect: '/dashboard',
    leaf: true,
    menuShow: true,
    iconCls: 'fa fa-home',
    children: [{ path: '/dashboard', component: Dashboard, name: '首页', menuShow: true }]
  }, {
    path: '/',
    component: Home,
    name: '事故故障',
    menuShow: true,
    leaf: true,
    children: [{ path: '/potential-check-table', component: PotentialCheckTable, name: '检查表管理', menuShow: true }, { path: '/potential-check-plan', component: PotentialCheckPlan, name: '检查计划', menuShow: true }, { path: '/potential-check', component: potentialCheck, name: '故障检查', menuShow: true }, { path: '/PotentialRectificationPre', component: PotentialRectificationPre, name: ' 故障整改', menuShow: true }, { path: '/PotentialReexaminePre', component: potentialReview, name: '故障复查', menuShow: true }, { path: '/potential-record', component: potentialRecord, name: '故障记录', menuShow: true }, { path: '/potential-danger-record', component: potentialDangerRecord, name: '排查故障记录', menuShow: true }, { path: '/PotentialExaminationPre', component: PotentialExaminationPre, name: '故障审核', menuShow: true }, { path: '/PotentialAssignmentPre', component: PotentialAssignmentPre, name: '故障下发', menuShow: true }, { path: '/PotentialApplyCancelPre', component: PotentialApplyCancelPre, name: '故障销号', menuShow: true }, { path: '/PotentialFilePre', component: PotentialFilePre, name: '故障归档', menuShow: true }, { path: '/potential-check-record', component: potentialCheckRecord, name: '检查记录', menuShow: true }, { path: '/FirstBusReport', component: FirstBusReport, name: '首班记录', menuShow: true }]
  }, {
    path: '/',
    component: Home,
    name: '积分管理',
    menuShow: true,
    leaf: true,
    children: [{ path: '/Integralset', component: Integralset, name: '积分设置', menuShow: true }, { path: '/Integralist', component: Integralist, name: '积分列表', menuShow: true }]
  }, {
    path: '/',
    component: Home,
    name: '日志管理',
    menuShow: true,
    leaf: true,
    children: [{ path: '/Logbook', component: Logbook, name: '行车日志', menuShow: true }, { path: '/Assess', component: Assess, name: '心理评测', menuShow: true }]
  }, {
    path: '/',
    component: Home,
    name: '安全例会管理',
    menuShow: true,
    leaf: true,
    children: [{ path: '/MeetTable', component: MeetTable, name: '安全例会', menuShow: true }]
  }, {
    path: '/',
    component: Home,
    name: '北斗监控系统',
    menuShow: true,
    leaf: true,
    children: [{ path: '/monitoring', component: Monitoring, name: '行北斗监控系统车日志', menuShow: true }]
  }, {
    path: '/',
    component: Home,
    name: '应急管理',
    menuShow: true,
    leaf: true,
    children: [{ path: '/reservePlan', component: reservePlan, name: '应急预案', menuShow: true }, { path: '/troops', component: troops, name: '应急队伍', menuShow: true }, { path: '/material', component: material, name: '应急物质', menuShow: true }, { path: '/drill', component: drill, name: '应急演练', menuShow: true }]
  }, {
    path: '/',
    component: Home,
    name: '三检调整',
    menuShow: true,
    leaf: true,
    children: [{ path: '/StaffInfo', component: StaffInfo, name: '三检调整', menuShow: true }]
  }, {
    path: '/',
    component: Home,
    name: '学习园地管理',
    menuShow: true,
    leaf: true,
    children: [{ path: '/Study', component: Study, name: '学习园地', menuShow: true }, { path: '/technicalnorm', component: technicalnorm, name: '技术规范', menuShow: true }, { path: '/law', component: law, name: '法律法规', menuShow: true }, { path: '/accidentcases', component: accidentcases, name: '典型事故案例', menuShow: true }, { path: '/learningrecord', component: learningrecord, name: '学习记录', menuShow: true }]
  }, {
    path: '/',
    component: Home,
    name: 'ADAS系管理',
    menuShow: true,
    leaf: true,
    children: [{ path: '/adas', component: Adas, name: 'ADAS系统', menuShow: true }]
  }, {
    path: '/',
    component: Home,
    name: '违章管理',
    menuShow: true,
    leaf: true,
    children: [{ path: '/violationList', component: violationList, name: '车辆违章记录', menuShow: true }]
  }, {
    path: '/',
    component: Home,
    name: '企业管理',
    menuShow: true,
    leaf: true,
    children: [{ path: '/EnterpriseInfo', component: EnterpriseInfo, name: '企业信息', menuShow: true }, { path: '/Driver', component: Driver, name: '驾驶员档案', menuShow: true }, { path: '/SafetyPerson', component: SafetyPerson, name: '安全管理 相关安全负责人', menuShow: true }, { path: '/MonitorPerson', component: MonitorPerson, name: '安全管理 专职监控人员', menuShow: true }, { path: '/NetworkDocumen', component: NetworkDocumen, name: '安全管理 安全生产管理网络图', menuShow: true }, { path: '/Escort', component: Escort, name: '押运员档案', menuShow: true }, { path: '/Stevedore', component: Stevedore, name: '装卸人员档案', menuShow: true }, { path: '/SafetyInput', component: SafetyInput, name: '安全投入', menuShow: true }, { path: '/Vehicle', component: Vehicle, name: '车辆档案', menuShow: true }, { path: '/SafetyMeeting', component: SafetyMeeting, name: '安全例会Old', menuShow: true }, { path: '/SafetyTrained', component: SafetyTrained, name: '安全培训', menuShow: true }, { path: '/Accident', component: Accident, name: '事故信息', menuShow: true }, { path: '/SpecialPersonnel', component: SpecialPersonnel, name: '特种设备作业人员', menuShow: true }, { path: '/SpecialEquipment', component: SpecialEquipment, name: '特种设备', menuShow: true }, { path: '/User', component: User, name: '用户管理', menuShow: true }, { path: '/organList', component: organList, name: '部门管理', menuShow: true }, { path: '/postList', component: postList, name: '岗位管理', menuShow: true }, { path: '/archives/ent', component: ent, name: '一企一档', menuShow: true }, { path: '/FileSign', component: FileSign, name: '文件签字管理', menuShow: true }]
  }, {
    path: '/',
    component: Home,
    name: '体系运行',
    menuShow: true,
    leaf: true,
    children: [{ path: '/Document', component: Document, name: '体系文件', menuShow: true }]
  }, {
    path: '/',
    component: Home,
    name: '风险管控',
    menuShow: true,
    leaf: true,
    children: [{ path: '/RiskUnit', component: RiskUnit, name: '风险单元', menuShow: true }, { path: '/RiskEvent', component: RiskEvent, name: '事故类型', menuShow: true }, { path: '/RiskControl', component: RiskControl, name: '风险分级管控', menuShow: true }, { path: '/Inspection', component: Inspection, name: '风险单元巡查', menuShow: true }]
  }, {
    path: '/',
    component: Home,
    name: '系统管理',
    menuShow: true,
    leaf: true,
    children: [{ path: '/Mail', component: Mail, name: '站内信', menuShow: true }, { path: '/Notices', component: Notices, name: '通知公告', menuShow: true }, { path: '/Password', component: Password, name: '修改密码', menuShow: true }, { path: '/UserInfo', component: UserInfo, name: '用户信息', menuShow: true }, { path: '/RegulatorWorkTask', component: RegulatorWorkTask, name: '工作任务', menuShow: true }, { path: '/RegulatorTrainTask', component: RegulatorTrainTask, name: '培训任务', menuShow: true }, { path: '/RegulatorPotentialTask', component: RegulatorPotentialTask, name: '隐患排查任务', menuShow: true }, { path: '/RegulatorSafetyMeetingTask', component: RegulatorSafetyMeetingTask, name: '安全例会任务', menuShow: true }]
  }, {
    path: '/',
    component: Home,
    name: '工作计划管理',
    menuShow: true,
    leaf: true,
    children: [{ path: '/workplanTable', component: workplanTable, name: '工作计划', menuShow: true }]
  }, {
    path: '/',
    component: Home,
    name: '参数配置',
    menuShow: true,
    leaf: true,
    children: [{ path: '/Sms', component: Sms, name: '短信推送', menuShow: true }, { path: '/PreExpirationConfig', component: PreExpirationConfig, name: '预过期时间配置', menuShow: true }]
  }, {
    path: '/',
    component: Home,
    name: '教育培训',
    menuShow: true,
    leaf: true,
    children: [{ path: '/Questions', component: Questions, name: '试题管理', menuShow: true }, { path: '/Paper', component: Paper, name: '试卷管理', menuShow: true }, { path: '/Courseware', component: Courseware, name: '课件管理', menuShow: true }, { path: '/Course', component: Course, name: '课程管理', menuShow: true }, { path: '/Train', component: Train, name: '培训计划', menuShow: true }, { path: '/Traintask', component: Traintask, name: '培训任务', menuShow: true }, { path: '/TrainTaskDetail', component: TrainTaskDetail, name: '培训任务详情', menuShow: true }]

  }, {
    path: '/',
    component: Home,
    name: '培训管理',
    menuShow: true,
    leaf: true,
    children: [{ path: '/trainingManagement/safetyTrainingProgramList', component: safetyTrainingProgramList, name: '安全培训计划', menuShow: true }, { path: '/trainingManagement/trainingTask', component: trainingTask, name: '培训任务实施', menuShow: true }, { path: '/trainingManagement/latojaManagement', component: latojaManagement, name: '线下培训管理', menuShow: true }]
  }, {
    path: '/',
    component: Home,
    name: '学员端',
    menuShow: true,
    leaf: true,
    children: [{ path: '/student/myExam', component: myExam, name: '我的考试', menuShow: true }, { path: '/student/myTrain', component: myTrain, name: '我的培训', menuShow: true }]
  }, {
    path: '/',
    component: Home,
    name: '统计报表',
    menuShow: true,
    leaf: true,
    children: [{ path: '/WorkStatistics', component: WorkStatistics, name: '工作情况统计表', menuShow: true }, { path: '/UserStatistics', component: UserStatistics, name: '人员统计', menuShow: true }, { path: '/VehicleStatistics', component: VehicleStatistics, name: '车辆统计', menuShow: true }, { path: '/RiskStatistics', component: RiskStatistics, name: '风险统计', menuShow: true }, { path: '/PotentialStatistics', component: PotentialStatistics, name: '故障统计', menuShow: true }, { path: '/AccidentStatistics', component: AccidentStatistics, name: '事故统计', menuShow: true }, { path: '/SafetyMeetingStatistics', component: SafetyMeetingStatistics, name: '安全例会统计', menuShow: true }, { path: '/VehicleViolationStatistics', component: VehicleViolationStatistics, name: '车辆违章统计', menuShow: true }, { path: '/LogbookWeekStatictis', component: LogbookWeekStatictis, name: '车辆巡检周统计', menuShow: true }, { path: '/LogbookMonthStatictis', component: LogbookMonthStatictis, name: '车辆巡检月统计', menuShow: true }, { path: '/LogbookAbnormalStatictis', component: LogbookAbnormalStatictis, name: '车辆巡检工作汇总', menuShow: true }]
  }, {
    path: '/',
    component: Home,
    name: '资讯中心',
    menuShow: true,
    leaf: true,
    children: [{ path: '/information', component: information, name: '资讯中心', menuShow: true }]
  }, {
    path: '/',
    component: Home,
    name: '车辆线路',
    menuShow: true,
    leaf: true,
    children: [{ path: '/DrivingLine', component: DrivingLine, name: '路线管理', menuShow: true }, { path: '/AddDrivingLine', component: AddDrivingLine, name: '添加路线', menuShow: true }]
  }, {
    path: '/',
    component: Home,
    name: '文件管理',
    menuShow: true,
    leaf: true,
    children: [{ path: '/EnterpriseUploadFile', component: EnterpriseUploadFile, name: '企业上传文件', menuShow: true }, { path: '/EnterpriseUploadDetailFile', component: EnterpriseUploadDetailFile, name: '企业上传详细文件', menuShow: true }]
  }, {
    path: "*",
    redirect: "/404"
  }]
});

router.beforeEach(function (to, from, next) {
  if (to.path.startsWith('/login')) {
    window.localStorage.removeItem('userinfo');
    next();
  } else if (to.path.startsWith('/404')) {
    next();
  } else if (to.path.includes('http')) {
    window.open(to.fullPath.substr(1));
  } else {
    var user = window.localStorage.getItem('userinfo');
    if (!user) {
      next({ path: '/login' });
    } else {
      next();
    }
  }
});

exports.default = router;

/***/ }),

/***/ 322:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 323:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 324:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 325:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 326:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 327:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 328:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 329:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 330:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 332:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(203);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1dfbf560_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(723);
function injectStyle (ssrContext) {
  __webpack_require__(710)
}
var normalizeComponent = __webpack_require__(93)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1dfbf560_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 333:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_previewMedia_vue__ = __webpack_require__(205);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55cfb76a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_previewMedia_vue__ = __webpack_require__(724);
function injectStyle (ssrContext) {
  __webpack_require__(711)
}
var normalizeComponent = __webpack_require__(93)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-55cfb76a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_previewMedia_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55cfb76a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_previewMedia_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 391:
/***/ (function(module, exports) {

module.exports = {"_args":[["axios@0.21.4","D:\\myt-zt-traffic-enterprise-view"]],"_from":"axios@0.21.4","_id":"axios@0.21.4","_inBundle":false,"_integrity":"sha512-ut5vewkiu8jjGBdqpM44XxjuCjq9LAKeHVmoVfHVzy8eHgxxq8SbAVQNovDA8mVi05kP0Ea/n/UzcSHcTJQfNg==","_location":"/axios","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"axios@0.21.4","name":"axios","escapedName":"axios","rawSpec":"0.21.4","saveSpec":null,"fetchSpec":"0.21.4"},"_requiredBy":["/"],"_resolved":"https://registry.npmmirror.com/axios/-/axios-0.21.4.tgz","_spec":"0.21.4","_where":"D:\\myt-zt-traffic-enterprise-view","author":{"name":"Matt Zabriskie"},"browser":{"./lib/adapters/http.js":"./lib/adapters/xhr.js"},"bugs":{"url":"https://github.com/axios/axios/issues"},"bundlesize":[{"path":"./dist/axios.min.js","threshold":"5kB"}],"dependencies":{"follow-redirects":"^1.14.0"},"description":"Promise based HTTP client for the browser and node.js","devDependencies":{"coveralls":"^3.0.0","es6-promise":"^4.2.4","grunt":"^1.3.0","grunt-banner":"^0.6.0","grunt-cli":"^1.2.0","grunt-contrib-clean":"^1.1.0","grunt-contrib-watch":"^1.0.0","grunt-eslint":"^23.0.0","grunt-karma":"^4.0.0","grunt-mocha-test":"^0.13.3","grunt-ts":"^6.0.0-beta.19","grunt-webpack":"^4.0.2","istanbul-instrumenter-loader":"^1.0.0","jasmine-core":"^2.4.1","karma":"^6.3.2","karma-chrome-launcher":"^3.1.0","karma-firefox-launcher":"^2.1.0","karma-jasmine":"^1.1.1","karma-jasmine-ajax":"^0.1.13","karma-safari-launcher":"^1.0.0","karma-sauce-launcher":"^4.3.6","karma-sinon":"^1.0.5","karma-sourcemap-loader":"^0.3.8","karma-webpack":"^4.0.2","load-grunt-tasks":"^3.5.2","minimist":"^1.2.0","mocha":"^8.2.1","sinon":"^4.5.0","terser-webpack-plugin":"^4.2.3","typescript":"^4.0.5","url-search-params":"^0.10.0","webpack":"^4.44.2","webpack-dev-server":"^3.11.0"},"homepage":"https://axios-http.com","jsdelivr":"dist/axios.min.js","keywords":["xhr","http","ajax","promise","node"],"license":"MIT","main":"index.js","name":"axios","repository":{"type":"git","url":"git+https://github.com/axios/axios.git"},"scripts":{"build":"NODE_ENV=production grunt build","coveralls":"cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js","examples":"node ./examples/server.js","fix":"eslint --fix lib/**/*.js","postversion":"git push && git push --tags","preversion":"npm test","start":"node ./sandbox/server.js","test":"grunt test","version":"npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json"},"typings":"./index.d.ts","unpkg":"dist/axios.min.js","version":"0.21.4"}

/***/ }),

/***/ 392:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _elementUi = __webpack_require__(285);

var _elementUi2 = _interopRequireDefault(_elementUi);

__webpack_require__(324);

var _vue = __webpack_require__(16);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(332);

var _App2 = _interopRequireDefault(_App);

var _router = __webpack_require__(321);

var _router2 = _interopRequireDefault(_router);

var _store = __webpack_require__(184);

var _store2 = _interopRequireDefault(_store);

var _constant = __webpack_require__(320);

var _constant2 = _interopRequireDefault(_constant);

var _echarts = __webpack_require__(186);

var _echarts2 = _interopRequireDefault(_echarts);

__webpack_require__(329);

__webpack_require__(323);

__webpack_require__(322);

__webpack_require__(328);

__webpack_require__(330);

var _unfold = __webpack_require__(191);

var _unfold2 = _interopRequireDefault(_unfold);

var _vue2OrgTree = __webpack_require__(337);

var _vue2OrgTree2 = _interopRequireDefault(_vue2OrgTree);

var _vueGeminiScrollbar = __webpack_require__(331);

var _vueGeminiScrollbar2 = _interopRequireDefault(_vueGeminiScrollbar);

var _vuePrintNb = __webpack_require__(334);

var _vuePrintNb2 = _interopRequireDefault(_vuePrintNb);

var _vueAmap = __webpack_require__(187);

var _vueAmap2 = _interopRequireDefault(_vueAmap);

var _vueSeamlessScroll = __webpack_require__(336);

var _vueSeamlessScroll2 = _interopRequireDefault(_vueSeamlessScroll);

var _customUpload = __webpack_require__(294);

var _customUpload2 = _interopRequireDefault(_customUpload);

var _previewMedia = __webpack_require__(333);

var _previewMedia2 = _interopRequireDefault(_previewMedia);

var _vueQuillEditor = __webpack_require__(335);

var _vueQuillEditor2 = _interopRequireDefault(_vueQuillEditor);

__webpack_require__(326);

__webpack_require__(327);

__webpack_require__(325);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

_vue2.default.component("Unfold", _unfold2.default);

_vue2.default.use(_vue2OrgTree2.default);

_vue2.default.use(_vueGeminiScrollbar2.default);

_vue2.default.use(_vuePrintNb2.default);

_vue2.default.use(_vueAmap2.default);

_vue2.default.use(_vueSeamlessScroll2.default);

_vue2.default.component("custom-upload", _customUpload2.default);

_vue2.default.component("preview-media", _previewMedia2.default);
_vueAmap2.default.initAMapApiLoader({
  key: 'f6aa4822ef075db57eaaffb737a91e64',
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.Geolocation', 'AMap.Geocoder', 'AMap.AMapManager', 'AMap.Driving', 'AMap.DragRoute', 'AMap.Marker'],
  v: '1.4.4',
  uiVersion: '1.0' });

_vue2.default.use(_vueQuillEditor2.default);

_vue2.default.prototype.$bus = new _vue2.default();
_vue2.default.prototype.$tableStyle = {
  background: '#F0F8FF', color: '#09558f'
};
_vue2.default.config.productionTip = false;
_vue2.default.prototype.$echarts = _echarts2.default;
_vue2.default.prototype.$const = _constant2.default;
_vue2.default.prototype.$checkPhone = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/;
_vue2.default.prototype.$checkPhoneNew = /(1[0-9]{10})|([0-9]{3,4})?[0-9]{7,8}/g;
_elementUi2.default.Dialog.props.closeOnClickModal.default = false;

_vue2.default.use(_elementUi2.default);

_vue2.default.filter('filterscolor', function (value) {
  var str = '';
  switch (value.Status) {
    case 10:
      str = "";
      break;
    case 20:
      str = "success";
      break;
    case 21:
      str = "danger";
      break;
    case 30:
      str = "success";
      break;
    case 40:
      str = "warning";
      break;
    case 50:
      break;
    case 61:
      break;
    case 62:
      break;
    case 60:
      break;
    case 70:
      break;
  }
  return str;
});

_vue2.default.directive('dialogDrag', {
  bind: function bind(el, binding, vnode, oldVnode) {
    var dialogHeaderEl = el.querySelector('.el-dialog__header');
    var dragDom = el.querySelector('.el-dialog');

    dialogHeaderEl.style.cssText += ';cursor:move;';
    dragDom.style.cssText += ';top:0px;';

    var sty = function () {
      if (window.document.currentStyle) {
        return function (dom, attr) {
          return dom.currentStyle[attr];
        };
      } else {
        return function (dom, attr) {
          return getComputedStyle(dom, false)[attr];
        };
      }
    }();

    dialogHeaderEl.onmousedown = function (e) {
      var disX = e.clientX - dialogHeaderEl.offsetLeft;
      var disY = e.clientY - dialogHeaderEl.offsetTop;

      var screenWidth = document.body.clientWidth;
      var screenHeight = document.documentElement.clientHeight;

      var dragDomWidth = dragDom.offsetWidth;
      var dragDomheight = dragDom.offsetHeight;

      var minDragDomLeft = dragDom.offsetLeft;
      var maxDragDomLeft = screenWidth - dragDom.offsetLeft - dragDomWidth;

      var minDragDomTop = dragDom.offsetTop;
      var maxDragDomTop = screenHeight - dragDom.offsetTop - dragDomheight;

      var styL = sty(dragDom, 'left');
      var styT = sty(dragDom, 'top');

      if (styL.includes('%')) {
        styL = +document.body.clientWidth * (+styL.replace(/\%/g, '') / 100);
        styT = +document.body.clientHeight * (+styT.replace(/\%/g, '') / 100);
      } else {
        styL = +styL.replace(/\px/g, '');
        styT = +styT.replace(/\px/g, '');
      };

      document.onmousemove = function (e) {
        var left = e.clientX - disX;
        var top = e.clientY - disY;

        if (-left > minDragDomLeft) {
          left = -minDragDomLeft;
        } else if (left > maxDragDomLeft) {
          left = maxDragDomLeft;
        }

        if (-top > minDragDomTop) {
          top = -minDragDomTop;
        } else if (top > maxDragDomTop) {
          top = maxDragDomTop;
        }

        dragDom.style.cssText += ';left:' + (left + styL) + 'px;top:' + (top + styT) + 'px;';
      };

      document.onmouseup = function (e) {
        document.onmousemove = null;
        document.onmouseup = null;
      };
    };
  }
});

_vue2.default.directive('has', {
  inserted: function inserted(el, binding) {
    if (!_vue2.default.prototype.$_has(binding.value)) {
      el.parentNode.removeChild(el);
    }
  }
});

_vue2.default.directive("input-limit", {
  bind: function bind(el, binding) {
    var wins_0 = /[^\d]/g;
    var wins_1 = /[^\d^\.]/g;
    var flag = true;
    var points = 0;
    var lengths = 0;
    var remainder = 0;
    var no_int = 0;
    var target = el instanceof HTMLInputElement ? el : el.querySelector("input");
    target.addEventListener("compositionstart", function (e) {
      flag = false;
    });
    target.addEventListener("compositionend", function (e) {
      flag = true;
    });
    target.addEventListener("input", function (e) {
      setTimeout(function () {
        if (flag) {
          if (binding.value == 0) {
            if (wins_0.test(e.target.value)) {
              e.target.value = e.target.value.replace(wins_0, "");
              e.target.dispatchEvent(new Event("input"));
            }
          }
          if (binding.value == 1) {
            if (wins_0.test(e.target.value.toString().replace(/\d+\.(\d*)/, '$1'))) {
              remainder = true;
            }
            if (e.target.value.split('.').length - 1 > 1) {
              points = true;
            }
            if (e.target.value.toString().split(".")[1] != undefined) {
              if (e.target.value.toString().split(".")[1].length > 1) {
                lengths = true;
              }
            }
            if (e.target.value.toString().indexOf(".") != -1) {
              no_int = false;
            } else {
              no_int = true;
            }
            if (wins_1.test(e.target.value) || lengths || points || remainder) {
              if (!no_int) {
                e.target.value = e.target.value.replace(wins_1, "").replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').substring(0, e.target.value.indexOf(".") + 2);
              } else {
                e.target.value = e.target.value.replace(wins_0, "");
              }
              e.target.dispatchEvent(new Event("input"));
            }
          }

          if (binding.value == 2) {
            if (wins_0.test(e.target.value.toString().replace(/\d+\.(\d*)/, '$1'))) {
              remainder = true;
            }
            if (e.target.value.split('.').length - 1 > 1) {
              points = true;
            }
            if (e.target.value.toString().split(".")[1] != undefined) {
              if (e.target.value.toString().split(".")[1].length > 2) {
                lengths = true;
              }
            }
            if (e.target.value.toString().indexOf(".") != -1) {
              no_int = false;
            } else {
              no_int = true;
            }
            if (wins_1.test(e.target.value) || lengths || points || remainder) {
              if (!no_int) {
                e.target.value = e.target.value.replace(wins_1, "").replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').substring(0, e.target.value.indexOf(".") + 3);
              } else {
                e.target.value = e.target.value.replace(wins_0, "");
              }
              e.target.dispatchEvent(new Event("input"));
            }
          }
        }
      }, 0);
    });
  }
});

_vue2.default.prototype.$_has = function (value) {
  var isExist = false;
  var buttonpermsStr = localStorage.getItem("perms");
  if (buttonpermsStr == undefined || buttonpermsStr == null) {
    return false;
  }
  var buttonperms = JSON.parse(buttonpermsStr);
  for (var i = 0; i < buttonperms.length; i++) {
    if (buttonperms[i].authority.indexOf(value) > -1) {
      isExist = true;
      break;
    }
  }
  return isExist;
};

_vue2.default.prototype.isNormalUser = function () {
  var isNormalUser = false;
  var userinfoStr = localStorage.getItem("userinfo");
  var userinfo = JSON.parse(userinfoStr);
  return userinfo.isNormalUser;
};

_vue2.default.filter('format', function (val, arg) {
  if (!val) return;
  var pattern = 'yyyy-MM-dd';
  if (arg) {
    pattern = arg;
  }

  return new Date(val).format(pattern);
});

Date.prototype.format = function (format) {
  var o = {
    "M+": this.getMonth() + 1,
    "d+": this.getDate(),
    "H+": this.getHours(),
    "m+": this.getMinutes(),
    "s+": this.getSeconds(),
    "q+": Math.floor((this.getMonth() + 3) / 3),
    "S": this.getMilliseconds() };
  if (/(y+)/i.test(format)) {
    format = format.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  }
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(format)) {
      format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
    }
  }
  return format;
};

new _vue2.default({
  el: '#app',
  router: _router2.default,
  store: _store2.default,
  template: '<App/>',
  components: { App: _App2.default }

});

/***/ }),

/***/ 710:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 711:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 712:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 713:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 723:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 724:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":_vm.title,"visible":_vm.visible,"width":"30%","before-close":_vm.VideoClose},on:{"update:visible":function($event){_vm.visible=$event}}},[_c('div',{class:{mp3: _vm.mediaType === 'mp3'}},[_c('video',{ref:"playVideo",staticClass:"video_avatar",attrs:{"src":_vm.src,"controls":"controls","controlslist":"nodownload"},on:{"contextmenu":function($event){$event.stopPropagation();$event.preventDefault();return (function() {return false}).apply(null, arguments)}}},[_vm._v("\n            您的浏览器不支持视频播放\n        ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 725:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.data.length<_vm.maxLen)?_c('span',[_c('span',{staticClass:"tj"},[_vm._v(_vm._s(_vm.data))])]):_c('span',[_c('span',{staticClass:"tj"},[_vm._v(_vm._s(_vm.showBtn?_vm.sliceStr:_vm.data)+"\n      "),_c('span',{staticClass:"btnWord",on:{"click":function($event){_vm.showBtn=!_vm.showBtn}}},[_vm._v(_vm._s(_vm.showBtn?_vm.tip:"收起"))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 726:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom-upload"},[_c('el-upload',_vm._b({attrs:{"action":_vm.url(),"accept":_vm.$attrs.accept || _vm.all_suffix,"list-type":_vm.listType,"before-upload":_vm.before,"on-change":function (file, fileList) {
                _vm.change(file);
            },"before-remove":function (file, fileList) {
                return _vm.before_remove(file);
            },"file-list":_vm.fileList,"on-preview":_vm.preview},scopedSlots:_vm._u([_vm._l((_vm.$scopedSlots),function(_,scopeSlotName){return {key:scopeSlotName,fn:function(scope){return [_vm._t(scopeSlotName,null,null,scope)]}}})],null,true)},'el-upload',_vm.$attrs,false),[_vm._l((_vm.$slots),function(_,slotName){return _vm._t(slotName,null,{"slot":slotName})})],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},[392]);


// WEBPACK FOOTER //
// static/js/app.cdc792c5c90350a4ed73.js